(() => {
  const existing = window.SPCollectionUI;
  if (existing) {
    existing.init(document);
    return;
  }

  const initializedCatalogs = new WeakSet();
  const initializedFaqs = new WeakSet();

  const initCatalog = (root) => {
    if (initializedCatalogs.has(root)) return;
    initializedCatalogs.add(root);

    const filters = Array.from(root.querySelectorAll('[data-spc-filter]'));
    const products = Array.from(root.querySelectorAll('[data-spc-product]'));
    const emptyState = root.querySelector('[data-spc-filter-empty]');

    filters.forEach((filterButton) => {
      filterButton.addEventListener('click', () => {
        const selectedCategory = filterButton.dataset.spcFilter;
        let visibleProducts = 0;

        filters.forEach((button) => {
          const isActive = button === filterButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        products.forEach((product) => {
          const isVisible = selectedCategory === 'all' || product.dataset.spcCategory === selectedCategory;
          product.hidden = !isVisible;
          if (isVisible) visibleProducts += 1;
        });

        if (emptyState) emptyState.hidden = visibleProducts !== 0;
      });
    });

    const sort = root.querySelector('[data-spc-sort]');
    sort?.addEventListener('change', () => sort.form?.requestSubmit());
  };

  const initFaq = (root) => {
    if (initializedFaqs.has(root)) return;
    initializedFaqs.add(root);

    const items = Array.from(root.querySelectorAll('[data-sp-faq-item]'));
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  };

  const init = (scope = document) => {
    const catalogs = [];
    const faqs = [];

    if (scope.matches?.('[data-spc-catalog]')) catalogs.push(scope);
    if (scope.matches?.('[data-sp-faq]')) faqs.push(scope);

    catalogs.push(...scope.querySelectorAll?.('[data-spc-catalog]') || []);
    faqs.push(...scope.querySelectorAll?.('[data-sp-faq]') || []);

    catalogs.forEach(initCatalog);
    faqs.forEach(initFaq);
  };

  window.SPCollectionUI = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
